import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "category-wrapper border-r w-60 shrink-0 border-r border-border bg-card py-4 hidden md:block overflow-y-auto" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("p", {
      class: "px-4 pb-2 text-xs font-semibold text-muted-foreground uppercase tracking-wider",
      "data-tsd-source": "/src/routes/_dashboard.partner.$partnerId.tsx:756:11"
    }, "Sections", -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
      return (_openBlock(), _createElementBlock("div", {
        key: category.id,
        class: _normalizeClass({
        'w-full text-left px-4 py-2.5 text-sm transition-colors text-muted-foreground hover:bg-accent hover:text-foreground': true,
        'category-item-active': category.id === _ctx.currentCategory,
      }),
        onClick: ($event: any) => (_ctx.openCategory(category.id))
      }, [
        _createElementVNode("div", null, _toDisplayString(category.name), 1)
      ], 10, _hoisted_2))
    }), 128)),
    _createElementVNode("div", {
      class: _normalizeClass({
        'w-full text-left px-4 py-2.5 text-sm transition-colors text-muted-foreground hover:bg-accent hover:text-foreground': true,
        'category-item-active': _ctx.currentCategory === _ctx.ATTACHMENTS_ID,
      }),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openAttachments && _ctx.openAttachments(...args)))
    }, [...(_cache[2] || (_cache[2] = [
      _createElementVNode("div", null, "Attachments", -1)
    ]))], 2),
    _createElementVNode("div", {
      class: _normalizeClass({
        'w-full text-left px-4 py-2.5 text-sm transition-colors text-muted-foreground hover:bg-accent hover:text-foreground': true,
        'category-item-active': _ctx.currentCategory === _ctx.ACTIVITY_ID,
      }),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openActivity && _ctx.openActivity(...args)))
    }, [...(_cache[3] || (_cache[3] = [
      _createElementVNode("div", null, "Activities", -1)
    ]))], 2)
  ]))
}